import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsSchemesAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-permissions-schemes-add',
	path: '/secure/admin/AddPermissionScheme!default.jspa',
};
